import { gql } from '__generated__'

export const SetFavoriteCandidate = gql(/* GraphQL */ `
    mutation SetFavoriteCandidate(
        $rosterCandidateId: ID!
        $isFavorited: Boolean!
    ) {
        updateFavorite(
            rosterCandidateId: $rosterCandidateId
            isFavorited: $isFavorited
        ) {
            success
            message
        }
    }
`)
